const errorMessages = {
  "Network Error": "Erro de conexão",
  "Invalid Credentials": "Usuário ou senha incorretos.",
  "Login Access Error": "Erro no acesso do usuário",
  "User account disabled": "Conta de usuário desativada",
  "Token Invalid": "Tempo de acesso esgotado.\nPor favor, logue-se novamente.",
  "Usuário desconectado.": "Tempo de acesso esgotado.\nPor favor, logue-se novamente.",
  "Invalid Token": "Token Inválido. Tente novamente.",
};
export default errorMessages;
